export const d20Distribution: {
    [key: string]: number[];
} = {
    "normal" : [
        100,
        95,
        90,
        85,
        80,
        75,
        70,
        65,
        60,
        55,
        50,
        45,
        40,
        35,
        30,
        25,
        20,
        15,
        10,
        5,
    ],
    "advantage" : [
        100,
        99.75,
        99,
        97.75,
        96,
        93.75,
        91,
        87.75,
        84,
        79.75,
        75,
        69.75,
        64,
        57.75,
        51,
        43.75,
        36,
        27.75,
        19,
        9.75,
    ],
    "disadvantage" : [
        100,
        90.25,
        81.1,
        72.25,
        64,
        56.4,
        49.2,
        42.4,
        36.1,
        30.3,
        24.9,
        20.25,
        16.0,
        12.25,
        8.9,
        6.25,
        3.9,
        2.25,
        1.0,
        0.2
    ],
}